export default __webpack_public_path__ + "static/media/creditCard.0b5a65ca.svg";